import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import CustomDatePicker from '@shared/components/CustomDatePicker';
import LoadingButton from '@shared/components/LoadingButton';
import { useArt123GenerateAgreementForm } from '../hooks/useArt123GenerateAgreementForm';

export default function Art123GenerateAgreementForm({ onClose, onConfirm }) {
    const {
        t,
        modalRef,
        reasons,
        loading,
        reasonsLoading,
        register,
        handleSubmit,
        setValue,
        watch,
        errors,
        selectedReason,
        submitForm,
        getReasonOptionLabel,
    } = useArt123GenerateAgreementForm({ onClose, onConfirm });

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {t('staff.art123.generateAgreement.title')}
                        </h4>
                    </div>
                    <form
                        id="art123GenerateAgreementForm"
                        className="region-form"
                        onSubmit={handleSubmit(submitForm)}
                    >
                        <div className="display-flex">
                            <div className="form-section">
                                <div className="form-group">
                                    <span>
                                        {t('staff.art123.generateAgreement.documentDate')}
                                        <span className="required">*</span>
                                    </span>
                                    <CustomDatePicker
                                        name="documentDate"
                                        value={watch('documentDate')}
                                        onChange={(date) => setValue('documentDate', date, { shouldValidate: true })}
                                        errors={errors}
                                        placeholderText={t('common.dateFormat')}
                                    />
                                </div>
                                <div className="form-group">
                                    <span>
                                        {t('staff.art123.generateAgreement.effectiveDate')}
                                        <span className="required">*</span>
                                    </span>
                                    <CustomDatePicker
                                        name="effectiveDate"
                                        value={watch('effectiveDate')}
                                        onChange={(date) => setValue('effectiveDate', date, { shouldValidate: true })}
                                        errors={errors}
                                        placeholderText={t('common.dateFormat')}
                                    />
                                </div>
                                <div className="form-group">
                                    <span>
                                        {t('staff.art123.generateAgreement.reason')}
                                        <span className="required">*</span>
                                    </span>
                                    <select
                                        className={`form-control ${errors.reasonId ? 'input-error' : ''}`}
                                        disabled={reasonsLoading}
                                        {...register('reasonId')}
                                    >
                                        <option value="">{t('common.select')}</option>
                                        {reasons.map((reason) => (
                                            <option
                                                key={reason.id}
                                                value={reason.id}
                                                title={reason.description}
                                            >
                                                {getReasonOptionLabel(reason)}
                                            </option>
                                        ))}
                                    </select>
                                    {selectedReason?.description && (
                                        <div className="select-option-preview">
                                            {selectedReason.description}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="modal-footer">
                        <LoadingButton
                            type="submit"
                            form="art123GenerateAgreementForm"
                            className="btn btn-primary"
                            loading={loading}
                        >
                            {t('common.generating')}
                        </LoadingButton>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
